import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/img/yunpan-icon@3x.png';
const _withScopeId = n => (_pushScopeId("data-v-5fbdc6df"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "file-item__pic"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "file-item-tackback",
  src: _imports_0,
  draggable: "false"
};
const _hoisted_4 = {
  class: "file-item__main"
};
const _hoisted_5 = {
  class: "file-item__name"
};
const _hoisted_6 = {
  class: "file-item__speed"
};
const _hoisted_7 = {
  key: 0,
  class: "margin"
};
const _hoisted_8 = {
  style: {
    "margin-left": "auto"
  }
};
const _hoisted_9 = {
  ref: "speedUp",
  class: "add-speed"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = ["src"];
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "file-item__option"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$file;
  const _component_SpeedUp = _resolveComponent("SpeedUp");
  const _directive_longpress = _resolveDirective("longpress");
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-item", {
      'is-unread': _ctx.unread,
      'is-disabled': _ctx.isTaskDeleted
    }]),
    onClick: _cache[3] || (_cache[3] =
    //@ts-ignore
    (...args) => _ctx.handleSelect && _ctx.handleSelect(...args))
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    class: "file-item-img",
    src: _ctx.iconLink,
    alt: "图片",
    draggable: "false"
  }, null, 8, _hoisted_2), _ctx.file.type === 'user#download' ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)]), _createElementVNode("article", _hoisted_4, [_createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.file.file_name || _ctx.file.name), 1), _createElementVNode("section", null, [_withDirectives(_createElementVNode("p", {
    class: _normalizeClass(["file-item__process", `process-${_ctx.speedBackground}`])
  }, [_createElementVNode("b", {
    style: _normalizeStyle({
      width: (_ctx.file.progress || 0) + '%'
    })
  }, null, 4)], 2), [[_vShow, _ctx.phase !== 'PHASE_TYPE_COMPLETE']]), _createElementVNode("p", _hoisted_6, [_withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.parseTime(new Date(_ctx.file.created_time))), 513), [[_vShow, _ctx.taskType !== 'ing']]), _createElementVNode("span", {
    class: _normalizeClass({
      'margin': _ctx.taskType !== 'ing'
    })
  }, _toDisplayString(_ctx.isWarn ? _ctx.warnInfo : _ctx.size) + " " + _toDisplayString(_ctx.lastTime), 3), _ctx.isTaskDeleted ? (_openBlock(), _createElementBlock("span", _hoisted_7, "文件不存在")) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString(_ctx.speedTxt) + " ", 1), _withDirectives(_createElementVNode("span", _hoisted_9, [(_ctx$file = _ctx.file) !== null && _ctx$file !== void 0 && (_ctx$file = _ctx$file.params) !== null && _ctx$file !== void 0 && _ctx$file.speedup ? (_openBlock(), _createBlock(_component_SpeedUp, {
    key: 0,
    "speed-up": _ctx.taskSpeedUp,
    task: _ctx.file,
    "is-v-i-p": _ctx.isVip,
    "is-s-v-i-p": _ctx.isSuperVip,
    "is-in-try": _ctx.isInTrySpeed,
    gcid: _ctx.file.params.hash,
    "info-hash": _ctx.file.params.info_hash,
    url: _ctx.file.params.url
  }, null, 8, ["speed-up", "task", "is-v-i-p", "is-s-v-i-p", "is-in-try", "gcid", "info-hash", "url"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [!_ctx.isAllTaskWithSensitiveResource && _ctx.speedupSpeed ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.speedVip), 1)) : _createCommentVNode("", true), _ctx.isTaskWithSensitiveResource ? (_openBlock(), _createElementBlock("span", {
    key: 1,
    class: "qh-icon-warn",
    onClick: _cache[0] || (_cache[0] = _withModifiers(
    //@ts-ignore
    (...args) => _ctx.handleWarn && _ctx.handleWarn(...args), ["stop"]))
  })) : _createCommentVNode("", true), _ctx.vipTeamJoined ? (_openBlock(), _createElementBlock("img", {
    key: 2,
    src: _ctx.MeetIcon,
    class: "huddle-icon",
    draggable: "false",
    onClick: _cache[1] || (_cache[1] = _withModifiers($event => _ctx.store.commit('toast', '组队加速已开启'), ["stop"]))
  }, null, 8, _hoisted_11)) : _createCommentVNode("", true), _ctx.svipJoined ? (_openBlock(), _createElementBlock("img", {
    key: 3,
    src: _ctx.SpeedTackIcon,
    class: "speed-lightning-icon",
    draggable: "false",
    onClick: _cache[2] || (_cache[2] = _withModifiers($event => _ctx.store.commit('toast', '超级加速已开启'), ["stop"]))
  }, null, 8, _hoisted_12)) : _createCommentVNode("", true)], 64))], 512), [[_vShow, _ctx.status === 'pause2' && _ctx.phase === 'PHASE_TYPE_RUNNING' && _ctx.file.type !== 'user#download']])])])])]), _withDirectives(_createElementVNode("div", _hoisted_13, [_createElementVNode("a", {
    href: "javascript:;",
    class: _normalizeClass(`qh-icon-${_ctx.status}`)
  }, null, 2)], 512), [[_vShow, _ctx.showCheckBtn]])], 2)), [[_directive_longpress, _ctx.handleSelectInLong]]);
}